// extracted by mini-css-extract-plugin
module.exports = {"radio":"formRadio_radio__tT39r","label":"formRadio_label__SXCOW","radioMark":"formRadio_radioMark__M2pKx","active":"formRadio_active__Q6rmE"};